import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { GeoPaymentMethodDepositLimits } from '@/models/ps-management/limits.model';

export default
class GetGeoPaymentMethodDepositLimitsRequest extends ApiResourceMethod<GeoPaymentMethodDepositLimits[]> {
  public perform(geoPaymentMethodId: string): Promise<GeoPaymentMethodDepositLimits[]> {
    return this.performer.requestWithMapper(
      { url: geoPaymentMethodId },
      (payload: BaseResponse<{ depositLimitList: GeoPaymentMethodDepositLimits[] }>) => {
        return payload.data.depositLimitList;
      },
    );
  }
}
